<template>
    <div>
        <Modal v-model="modelIndex" width="480" class="model_zdy model_perfect" @on-cancel="formInfoCancel">
            <div slot="header">
                <p class="tip">完善信息</p>
            </div>
            <div class="model_content">
                <Form ref="formInfo" :model="formInfo" label-position="right" :rules="perfectValidate" :label-width="80">
                    <FormItem label="姓名" prop="name">
                        <Input v-model="formInfo.name"></Input>
                    </FormItem>
                    <FormItem label="任职公司" prop="comp_name">
                        <Input v-model="formInfo.comp_name"></Input>
                    </FormItem>
                    <FormItem label="职务" prop="title">
                        <Input v-model="formInfo.title"></Input>
                    </FormItem>
                    <FormItem label="手机号" prop="mobile">
                        <Input v-model="formInfo.mobile"></Input>
                    </FormItem>
                    <FormItem label="验证码" prop="code">
                        <Input v-model="formInfo.code"></Input>
                        <span class="code_btn" @click="haddleCode()" v-if="userWait == 60">获取验证码</span>
                        <span class="code_btn disabled_btn" v-else="userWait != 60">已发送 ({{userWait}}s)</span>
                    </FormItem>
                    <FormItem label="邮箱" prop="email">
                        <Input v-model="formInfo.email"></Input>
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
              <Button @click="perfectInofSubmit">确定</Button>
              <Button @click="formInfoCancel">取消</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
import { sendCode, perfect, checkTel } from '../service'
import moment from 'moment'
import Cookies from 'js-cookie'
export default {
  name: 'PerfectInfo',
  props: ['perfectModalIndex'],
  computed: {
    before_user_key() {
      return this.$store.state.before_user_key
    }
  },
  data() {
    return {
      modelIndex: false,
      formInfo: {
        mobile: '',
        email: '',
        title: '',
        name: '',
        comp_name: '',
        code: ''
      },
      perfectValidate: {
        'name': [
            { required: true, message: '请输入您的姓名', trigger: 'blur' }
        ],
        'comp_name': [
            { required: true, message: '请输入当前任职机构/公司', trigger: 'blur' }
        ],
        'title': [
            { required: true, message: '请输入当前任职职务', trigger: 'blur' }
        ],
        'mobile': [
            { required: true, message: '请输入您的手机号', trigger: 'blur' },
            { type: 'number', message: '手机号格式不正确', trigger: 'blur', transform(value) {
              let reg = /^1[3456789]\d{9}$/
              if (!reg.test(value)) {
                return false
              } else {
                return Number(value)
              }
            }},
            {validator: this.checkTel, trigger: 'change'}
        ],
        'code': [
            { required: true, message: '请输入您的手机验证码', trigger: 'blur' },
        ],
        'email': [
            { required: true, message: '请输入您的邮箱', trigger: 'blur' },
            { type: 'email', message: '邮箱格式不正确', trigger: 'blur' }
        ]
      },
      userWait: 60,
      codeTimeout: ''
    }
  },
  methods: {
    haddleCode() {
      this.$refs['formInfo'].validateField('mobile', async (valid) => {
        if (!valid) {
          this.userCodeClk()
          let res = await sendCode({mobile: this.formInfo.mobile}, (error) => {
            this.$Message.error('请求失败！')
          })
        }
      })
    },
    perfectInofSubmit() {
      this.$refs['formInfo'].validate(async (valid) => {
        if (valid) {
          let res = await perfect(Object.assign(this.formInfo, {user_key: this.before_user_key}), (error) => {
            this.$Message.error('请求失败！')
          })
          if (res.status == 'success') {
            Cookies.set('user_key_'+this.$store.state.cookie_type, res.user_key, { domain: this.$store.state.domain_path, path: '/', expires: this.$store.state.oneYearFromNow })
            
            this.$store.commit('updateUserKey', res.user_key)
            this.$store.commit('updateUser', res.user)
            this.formInfoCancel()
          } else {
            console.log(res)
          }
        }
      })
    },
    async checkTel(rule, value, callback) {
      let res = await checkTel({mobile: value, user_key: this.before_user_key}, (error) => {
        this.$Message.error('请求错误！')
      })
      if(res.status == 'success') {
        if(res.is_exit) {
          callback(new Error('该手机号已经申请过了'))
        } else {
          callback()
        }
      } else {
        callback(new Error('手机号码验证失败'))
      }
    },
    userCodeClk() {
      if (this.userWait == 0) {
          this.userWait = 60;
      } else {
          this.userWait --;
          this.codeTimeout = setTimeout(() => { this.userCodeClk() }, 1000)
      }
    },
    formInfoCancel() {
      this.userWait = 60;
      clearTimeout(this.codeTimeout)
      this.$refs['formInfo'].resetFields()
      this.$emit('cancel', false)
    }
  },
  watch: {
    perfectModalIndex(val) {
      this.modelIndex = val
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/common.stylus'
.model_zdy
  & >>> .ivu-modal-content
    .model_content
      padding: 14px 14px 0
      .ivu-form
        margin-top: 16px
        .ivu-form-item
          margin-bottom: 10px
          .ivu-form-item-content
            .ivu-input
              background: #F8F8FA
              border-color: #F8F8FA
              border-radius: 4px
              color: #333
              height: 40px
              font-size: 14px
              padding: 10px
              &::-webkit-input-placeholder
                color: #999
              &:focus
                box-shadow: none
                border-color: #FA5A00
            .code_btn
              position: absolute
              cursor: pointer
              line-height: 1
              color: #FA5A00
              top: 14px
              right: 10px
              &.disabled_btn
                color: #999999
          &:last-of-type
              margin-bottom: 0
          .ivu-form-item-error-tip
            position: inherit
            color: #F3494B
          &.ivu-form-item-error
            .ivu-input
              border-color: #F3494B
  & >>> .ivu-modal-footer
    padding: 4px 30px 20px
    border-top: 0
    .ivu-btn
      width: 100%
      height: 40px
      background: #FA5A00
      border-radius: 4px
      border-color: #FA5A00
      font-size: 14px
      color: #FFFFFF
      &:focus
        box-shadow: none
.model_perfect
  & >>> .ivu-modal-close
    top: 8px
    right: 10px
  & >>> .ivu-modal-body
    .model_content
      padding: 14px
      .ivu-form
        margin-top: 0
        .ivu-form-item-label
          font-size: 14px
          color: #333
          padding: 13px 12px 13px 0
        .ivu-form-item
          margin-bottom: 24px
          .ivu-form-item-error-tip
            position: absolute
          .ivu-form-item-content
            .ivu-input
              background: #fff
              border-color: #e8e8e8
  & >>> .ivu-modal-footer
    padding: 20px 30px
    border-top: 1px solid #f5f5f5
    .ivu-btn
      width: auto
      &:last-of-type
        background: #fff
        border-color: #dadce2
        color: #333
</style>
